<template>
  <liste-template>
    <template #header>
      <h1 class="title is-size-3">{{ $t('ajoutProduitSurRegroupement.title') }}</h1>
      <qd-breadcrumb :breadcrumb="breadcrumb"/>
    </template>
    <template #action>
      <div class="buttons">
        <a @click="annuler()" class="button">
          {{ $t('general.button.return')}}
        </a>
      </div>
    </template>
    <template #bar-right>
      <div class="is-inline-block mgt-1 mgr-4">
        <button class="button" @click="showComponentFilter = constantes.filtreComponentName">
          <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7">{{ $t('general.button.maRecherche') }}</span>
        </button>
        <div v-if="nombreCritere" class="info-circle-right background-danger is-pulled-right">
          <span class="inside-circle"> {{ nombreCritere }} </span>
        </div>
      </div>
      <div class="is-inline-block mgt-1 mgr-4">
        <button class="button" @click="showComponentFilter = constantes.selectionComponentName">
          <b-icon icon="cart-outline" size="is-small" type="is-default"></b-icon>
          <span class="is-size-7">{{ $t('general.button.selection') }}</span>
        </button>
        <div v-if="nombreSelection" class="info-circle-right background-danger is-pulled-right">
          <span class="inside-circle"> {{ nombreSelection }} </span>
        </div>
      </div>
      <parametrage-table
        :reference-table="referenceTable"
        @endLoadParamtre="startArrayRendering = true">
      </parametrage-table>
    </template>
    <template #content>
      <v-server-table
        url=""
        :columns="columns"
        :options="options"
        :ref="referenceTable"
        @loading="debutLoading"
        @loaded="finLoading"
        @error="finLoading"
        v-if="mountedLoadingEnd && startArrayRendering">
        <template slot="afterTable">
          <table-items-in-view
            :perPage="constantes.RESULTS_PER_PAGE_PLANNING"
            @input="$refs[referenceTable].setLimit($event)"/>
        </template>
        <template #addPanier="{ row }">
          <div class="has-text-centered">
            <button
              @click="ajouterALaSelection(row)"
              :class="getColorAddPanier(row.id)"
              class="ripple button">
              <b-icon icon="plus-circle"></b-icon>
            </button>
          </div>
        </template>
        <template #reference="{ row }">
          <router-link
            :to="{
              name: getLibelleAndRoutesForProduct(row).routeDetail,
              params: {id: row.id}
            }"
            :class="{'text-access-no-permission': !checkPermissions(constantes.CATALOGUE.lecture)}"
            class="lien">
            {{ row.reference }}
          </router-link>
        </template>
        <template #type="{ row }">
          {{ $t(getLibelleAndRoutesForProduct(row).libelle) }}
        </template>
        <template #actif="{ row }">
          {{ getLibelleArchive(row.actif) }}
        </template>
      </v-server-table>
    </template>
    <template #filter>
      <div
        v-if="showComponentFilter"
        class="componentBrief">
        <filtre-liste
          v-if="showComponentFilter === constantes.filtreComponentName"
          @toggleFiltre="showComponentFilter = null"
          @recherche="makeRechercheFilter()"
          :storeName="storeName"/>
        <selection-liste
          v-if="showComponentFilter === constantes.selectionComponentName"
          @toggleSelection="showComponentFilter = null"
          @ajoutProduitsSelectionnes="ajoutSelectionToRegroupement"
          :storeName="storeName"
          :forSelectionFaceOnly="false"/>
      </div>
    </template>
  </liste-template>
</template>

<script>
import cloneDeep from 'lodash/cloneDeep';
import { createNamespacedHelpers } from 'vuex';
import QdBreadcrumb from '@/components/general/breadcrumb';
import TableItemsInView from '@/components/general/TableItemsInView';
import ListeTemplate from '@/components/general/template/listeTemplate';
import FiltreListe from '@/components/presse/regroupementProduit/produits/filtreListeProduitsSurRegroupement';
import SelectionListe from '@/components/catalogue/selectionProduit/selectionAjoutProduits';
import ParametrageTable from '@/components/general/parametrageTable';
import messageErreur from '@/services/general/messageErreur';
import subscribeMutation from '@/services/store/subscribeMutation';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import tagInputToArray from '@/services/general/filters/tagInputToArray';
import {
  TEXTS,
  SORT_ICON,
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE_PLANNING,
} from '@/configuration/clientTableConf';
import * as produitConf from '@/configuration/catalogue/produitConf';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import { REFERENCE_TABLE_LISTE_PRODUIT } from '@/configuration/general/referenceTableConf';
import produitStore from '@/store/modules/produit';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import { SET_DETECT_CHANGE_SOCIETE, SET_LOCK_MENU } from '@/store/modules/societe-mutation-type';
import { SET_PRODUITS } from '@/store/modules/bodac/catalogue/regroupementProduit-mutation-type';
import { SET_PANIER, ADD_LIGNE_IN_PANIER_AT_END, DELETE_LIGNE_IN_PANIER } from '@/store/modules/produit-mutation-type';

const User = createNamespacedHelpers('user');
const Societe = createNamespacedHelpers('societe');
const Parametres = createNamespacedHelpers('parametres');
const Permissions = createNamespacedHelpers('permissions');
const RegroupementProduit = createNamespacedHelpers('regroupementProduit');

export default {
  name: 'ListeAjouteProduitsSurRegroupement',
  props: {
    storeName: {
      type: String,
      required: true,
    },
  },
  components: {
    FiltreListe,
    QdBreadcrumb,
    ListeTemplate,
    SelectionListe,
    TableItemsInView,
    ParametrageTable,
  },
  data() {
    return {
      startArrayRendering: false,
      mountedLoadingEnd: false,
      loadingComponent: null,
      unsubscribeValue: null,
      showComponentFilter: null,
      produitStore,
      referenceTable: REFERENCE_TABLE_LISTE_PRODUIT,
      constantes: {
        filtreComponentName: 'FiltreListe',
        selectionComponentName: 'SelectionListe',
        RESULTS_PER_PAGE_PLANNING,
        CATALOGUE,
      },
    };
  },
  computed: {
    ...User.mapGetters({
      user: 'user',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    ...Societe.mapGetters({
      lockMenu: 'lockMenu',
      agenceActive: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
    ...RegroupementProduit.mapGetters({
      produitsRegroupement: 'produits',
    }),
    selections() {
      return this.$store.getters[`${this.storeName}/panier`];
    },
    produits() {
      return this.$store.getters[`${this.storeName}/produits`];
    },
    lastPayload() {
      return this.$store.getters[`${this.storeName}/lastPayload`];
    },
    totalProduits() {
      return this.$store.getters[`${this.storeName}/totalProduits`];
    },
    criteresRecherche() {
      return this.$store.getters[`${this.storeName}/criteresRecherche`];
    },
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    breadcrumb() {
      const current = {
        title: this.$t('ajoutProduitSurRegroupement.title'),
        route: { name: 'm.bodac.catalogue-ajoutProduitsSurRegroupement' },
        isActive: true,
      };
      if (Object.prototype.hasOwnProperty.call(this.$route.params, 'breadcrumb')) {
        const output = Array.from(this.$route.params.breadcrumb);
        output[output.length - 1].isActive = false;
        output.push(current);
        return output;
      }
      return [current];
    },
    nombreCritere() {
      const banCritereKey = ['actif', 'avecLiaisons'];
      let nbCritere = calculNombreCritere(this.criteresRecherche, banCritereKey);
      nbCritere += this.criteresRecherche.actif !== null ? 1 : 0;
      nbCritere += this.criteresRecherche.avecLiaisons !== null ? 1 : 0;
      return nbCritere <= 9 ? nbCritere : '+9';
    },
    nombreSelection() {
      return this.selections.length > 9 ? '9+' : this.selections.length;
    },
    columns() {
      return [
        'addPanier',
        'reference',
        'type',
        'libelle',
        'actif',
      ];
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          addPanier: '',
          reference: this.$i18n.t('ajoutProduitSurRegroupement.table.reference'),
          libelle: this.$i18n.t('ajoutProduitSurRegroupement.table.libelle'),
          type: this.$i18n.t('ajoutProduitSurRegroupement.table.type'),
          actif: this.$i18n.t('ajoutProduitSurRegroupement.table.actif'),
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: RESULTS_PER_PAGE_PLANNING,
        texts: TEXTS,
        sortable: [
          'reference',
          'libelle',
        ],
        columnsClasses: {
          addPanier: 'colonneSelected-35 is-paddingless',
        },
        requestFunction: ((data) => {
          if (this.filtrerProduitParAgence && this.criteresRecherche.agencesId.length === 0) {
            this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
          }
          if (!data.query) data.query = cloneDeep(this.criteresRecherche);
          data.query.categorie = tagInputToArray(this.criteresRecherche.categorie, 'code');
          if (this.filtrerProduitParSociete) data.query.societeId = this.societeActiveId;
          if (this.user.agences.length === 1) {
            data.query.agencesId = [this.user.agences[0].agenceId];
          }
          return this.$store.dispatch(`${this.storeName}/loadProduits`, data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produits,
            count: this.totalProduits,
          };
        }),
      };
    },
  },
  methods: {
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...Societe.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    ...Societe.mapMutations({
      setLockMenu: SET_LOCK_MENU,
    }),
    ...RegroupementProduit.mapMutations({
      setProduits: SET_PRODUITS,
    }),
    annuler() {
      this.$router.go(-1);
    },
    recherche() {
      this.$refs[this.referenceTable].refresh();
    },
    goFirstPage() {
      this.$refs[this.referenceTable].setPage(1);
    },
    makeRechercheFilter() {
      this.showComponentFilter = null;
      this.recherche();
    },
    debutLoading() {
      if (this.loadingComponent) this.loadingComponent.close();
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    ajouterALaSelection(produit) {
      const findIndex = this.selections.findIndex((p) => p.produit.id === produit.id);
      if (findIndex === -1) {
        this.$store.commit(`${this.storeName}/${ADD_LIGNE_IN_PANIER_AT_END}`, {
          produit: produit,
          isAlreadySelect: false,
        });
      } else {
        const selection = this.selections[findIndex];
        const payload = { index: findIndex, isAlreadySelect: selection.isAlreadySelect };
        this.$store.commit(`${this.storeName}/${DELETE_LIGNE_IN_PANIER}`, payload);
      }
    },
    getColorAddPanier(idProduit) {
      if (!this.selections) return 'is-primary';
      const isAlreadyAdd = this.selections.some((p) => idProduit === p.produit.id);
      return isAlreadyAdd ? 'is-success' : 'is-primary';
    },
    ajoutSelectionToRegroupement() {
      const produits = this.selections.map(p => p.produit);
      this.setProduits(produits);
      this.annuler();
    },
    getLibelleAndRoutesForProduct(produit) {
      const produitConfiguration = produitConf.CATEGORIE_PRODUIT.find((p) => {
        return p.code === produit.supportCommercial.categorieVente;
      });
      if (!produitConfiguration) return '';
      if (produitConfiguration.code !== produitConf.CATEGORIE_LOCATION) return produitConfiguration;
      return produit.numerique ? produitConfiguration.numerique : produitConfiguration.nonNumerique;
    },
    getLibelleArchive(actif) {
      if (actif) return this.$t('general.non');
      return this.$t('general.oui');
    },
    updateAgenceAndRecherche() {
      if (this.filtrerProduitParAgence) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.recherche();
    },
  },
  beforeMount() {
    if (!this.$route.params.breadcrumb || !this.produitsRegroupement) {
      this.setProduits(null);
      if (this.loadingComponent) this.loadingComponent.close();
      this.annuler();
      return;
    }
    const loadingComponent = this.$buefy.loading.open();
    const selections = cloneDeep(this.produitsRegroupement).map((p) => ({
      produit: p,
      isAlreadySelect: true,
    }));
    this.$store.commit(`${this.storeName}/${SET_PANIER}`, selections);
    loadingComponent.close();
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadSocietes({});
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
      ]);
      if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
        this.unsubscribeValue = await subscribeMutation(
          this.$store,
          'societe/' + SET_DETECT_CHANGE_SOCIETE,
          this.updateAgenceAndRecherche,
          this.goFirstPage);
      }
      if (this.user.agences.length > 1) {
        this.criteresRecherche.agencesId = this.agenceActive.map((agence) => agence.agenceId);
      }
      this.mountedLoadingEnd = true;
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  beforeDestroy() {
    if (this.filtrerProduitParSociete || this.filtrerProduitParAgence) {
      this.unsubscribeValue();
    }
    if (this.lockMenu) this.setLockMenu(false);
  },
};
</script>
